import React from "react";
import { FastField } from "formik";
import PropTypes from "prop-types";

import { ExclamationCircleIcon } from "@heroicons/react/solid";
import Input from "./Input";

const LabeledFormField = (props) => {
  const allProps = { ...props };
  delete allProps.label;
  delete allProps.errorMessage;
  return (
    <FastField name={props.name}>
      {({ field, form }) => {
        const name = props.name;
        const error = form.errors[name];
        const touched = form.touched[name];
        return (
          <div className="mt-3">
            <div className="flex justify-between">
              <label className="block text-sm font-medium text-gray-700">
                {props.label}
              </label>
              <span className="text-sm text-red-500">
                {props.errorMessage || error}
              </span>
            </div>
            <div className="mt-1 relative rounded-md shadow">
              <Input
                className="w-full"
                type={props.type}
                {...field}
                {...allProps}
                intent={error && touched ? "danger" : ""}
              />
              {error && touched && (
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <ExclamationCircleIcon
                    className="h-5 w-5 text-red-500"
                    aria-hidden="true"
                  />
                </div>
              )}
            </div>
          </div>
        );
      }}
    </FastField>
  );
};

LabeledFormField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
};

export default LabeledFormField;
